import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

//Insert New Office Vendor Service
export const addOfficeVendorService = async (newOfficeVendorOfc) => {
  return await axios.post(`${api_base_url}/OfficeVendorService`, {
    ...newOfficeVendorOfc,
  });
};

//Get Service Provided
export const getServiceProvided = async () => {
  const data = await axios.get(
    `${api_base_url}/OfficeVendorService/ServiceProvided`
  );
  return data;
};

//Get Service Provided
export const getAllVendorForVendorService = async () => {
  const data = await axios.get(
    `${api_base_url}/OfficeVendorService/AllVendorsForVendorService`
  );
  return data;
};

//Get Office Vendor Service
export const getOfficeVendorServiceByOfficeId = async (officeId) => {
  return await axios
    .get(`${api_base_url}/OfficeVendorService/OfficeId/${officeId}`)
    .then((res) => {
      return res.data;
    });
};

// Get Office Vendor Service By Record Number
export const getOfcVendorServiceForEdit = async (recordNumber) => {
  return await axios
    .get(`${api_base_url}/OfficeVendorService/ForEdit/${recordNumber}`)
    .then((res) => {
      return res.data;
    });
};

//Edit Office Vendor Service
export const updateOfficeVendorService = async (editSOfcVendorSvc) => {
  return await axios.put(
    `${api_base_url}/OfficeVendorService/${editSOfcVendorSvc.recordNumber}`,
    editSOfcVendorSvc
  );
};

// Deactivate Office Vendor Service
export const deactivateOfcVendorSvcByRecordId = async (deactivateOvs) => {
  return await axios.delete(
    `${api_base_url}/OfficeVendorService/OfficeVendorServiceToDeactivate/${deactivateOvs.fromModule}`,
    {
      data: deactivateOvs.id,
    }
  );
};
